import { render, staticRenderFns } from "./NexusStateForm.vue?vue&type=template&id=c973ad88"
import script from "./NexusStateForm.vue?vue&type=script&lang=js"
export * from "./NexusStateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports